<template>
    <div class="container float-page" id="eventsucces">
  <div class="container-fluid"> 
    <!-- Float Box -->
    <div class="float-box">
      <div class="card"> 
        <!-- Float Card Body -->
        <div class="card-body float-card-body">
          <h1 class="mb-3"> {{$t('common.eventsucces.t1')}} </h1>
          <p class="float-box-msg mb-2">{{$t('common.eventsucces.t2')}}</p>
          <el-button type="primary"    class="btn btn-block btn-primary" @click="Tomain()">{{$t('common.eventsucces.t3')}}</el-button>
         </div>
        <!-- /.float-card-body --> 
      </div>
    </div>
    <!-- ./float box --> 
  </div>
</div>
</template>
<script>
export default {
    methods:{
      Tomain(){
        this.$router.push({name:'eventList'})
      },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/eventsucces.vue